import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { LoginButtonPage } from './loginButtonWillMount'
import { ComponentWillMountSymbol } from 'feature-components'

export const page: ContainerModuleLoader = (bind) => {
	bind(ComponentWillMountSymbol).to(LoginButtonPage)
}

export const editorPage = page
